import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['es', 'en'],
    debug: false,
    resources: messages,
    detection: {
      // Order of detection: localStorage first (user preference), then browser language
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'abc_lang',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
